var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-popup-component',{on:{"showAuthModal":_vm.showAuthModal,"carouselChange":_vm.carouselChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }